import { useEffect, useState } from "react";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import useFacility from "../../../utils/hooks/useFacility";
import { GET_EXERCISE_BY_DAY } from "../../api/apiRoutes";
import { addDays, format, isAfter } from "date-fns";
import { Exercise } from "../../models/Exercise";
import { ExerciseForHourlySchedule } from "../../models/ExerciseForHourlySchedule";

/* eslint-disable import/no-anonymous-default-export */
export default () => {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [data, setData] = useState<{ [name: string]: ExerciseForHourlySchedule[] }>();
  const [dataMessage, setDataMessage] = useState("");

  const groupExerciseByName = (data: Exercise[]) => {
    const groupedExercises: { [name: string]: ExerciseForHourlySchedule[] } = {};

    data.forEach((exercise) => {
      const { name, objectId, objectDb, startTime, closeTime, capacity, reserved } = exercise;

      if (groupedExercises[name]) {
        groupedExercises[name].push({
          name,
          objectId,
          objectDb,
          startTime,
          closeTime,
          capacity,
          reserved,
        });
      } else {
        groupedExercises[name] = [{ name, objectId, objectDb, startTime, closeTime, capacity, reserved }];
      }
    });

    return groupedExercises;
  };

  const getScheduleExercises = async () => {
    setLoading(true);
    const formattedDate = format(selectedDate, "yyyy-MM-dd");
    const { result, isError } = await get(GET_EXERCISE_BY_DAY(facilityIds, formattedDate));
    if (!isError) {
      if (result.length > 0) {
        const groupedData = groupExerciseByName(result);
        setData(groupedData);
        setDataMessage("");
      } else {
        setDataMessage("Brak wydarzeń w wybranym dniu");
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getScheduleExercises();
    //eslint-disable-next-line
  }, [selectedDate]);

  const isSelectedDateAfter31Days = () => {
    return isAfter(selectedDate, addDays(new Date(), 31));
  };

  return { loading, data, selectedDate, setSelectedDate, dataMessage, isSelectedDateAfter31Days };
};
